// extracted by mini-css-extract-plugin
export default {"button":"NavigationItem_button__QfRh0","active":"NavigationItem_active__1CWFu","space":"NavigationItem_space__rcKzk"};